import React from 'react'
/* --------------------------------------------- */
/* --------------------------------------------- */
import Button from "../../../form/Button"

import { ButtonWrapper, InfoCtaDesc } from '../styles'
import "../_landing-page.scss";

/* --------------------------------------------- */
// GenericBottom component for showing pageComponent
const GenericBottom = (props) => {
  // const { graphics } = theme
  // const [theme, updateTheme] = useState(null)
  const { sectionData, contentData, homePageRedirectHandler, themeSection:theme = {} } = props
  const componentData  = sectionData
  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  /**
   * It: Updates theme.
   */
  // useEffect(() => {
  //   updateTheme(appTheme)
  // }, [appTheme])

  const ctaDataInfo = (
    <div style={{textAlign: 'center'}}>
      {
        componentData.ctaDescription && (
          <InfoCtaDesc {...{ theme }} className='infoSection__ctadesc'>{componentData.ctaDescription}</InfoCtaDesc>
        )
      }
      {
        componentData.ctaData && (
          <ButtonWrapper {...{ theme }}>
              <Button {...{title: componentData.ctaData}}  onClick={homePageRedirectHandler} />
          </ButtonWrapper>
        )
      }
    </div>
  )

  return (
    <>
      <div className="asset-component">
        {/* <div className="asset-component-layer" style ={{position: 'fixed',
        width: '100%',
        height: '100%',
        top: '0',
        left: '230px',
      }}></div> */}
        {
          contentData.map((data, idx) => {
            const { graphics : { img }} = data
            return (
              <div className="asset-section" key={idx}>
                <img src={img} alt="asset"/>
                {/* Disabling card description - as per comments from Padmaj/Jithin */}
                {/* {title && (
                  <InfoTitle {...{ theme }} className='infoSection__title'>{title}</InfoTitle>
                )} */}
              </div>
            )
          })
        }
      </div>
      {ctaDataInfo}
    </>
  )
}


/* --------------------------------------------- */
GenericBottom.propTypes = {

}
/* --------------------------------------------- */
GenericBottom.defaultProps = {

}
/* --------------------------------------------- */
export default GenericBottom
